<template>
  <div class="px-3">
    <div class="relative">
      <a v-if="venue.photos.length" :href="`/${venue.path}`" class="relative block overflow-hidden rounded pb-62%">
        <div class="absolute flex size-full justify-center bg-gray-400 bg-cover align-middle">
          <picture>
            <source v-if="venue.photos[0].photo_rectangular_webp" :srcset="venue.photos[0].photo_rectangular_webp" type="image/webp">
            <source :srcset="venue.photos[0].photo_rectangular" type="image/jpeg">
            <img
              draggable="false"
              class="absolute left-0 size-full object-cover"
              :src="venue.photos[0].photo_rectangular"
              :alt="venue.name"
              loading="lazy"
            >
          </picture>
        </div>
      </a>
      <div class="absolute bottom-0 right-0 z-10 mb-4 mr-2">
        <a
          href="#"
          class="mr-1 inline-block rounded bg-lime px-2 py-1px text-smm font-medium"
          @click.prevent="$emit('click', venue)"
        >
          {{ Math.floor(venue.tripexpert_score / 10) }}
          <div class="inline-block">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 4.25L7.41406 6.62305L8.625 10.5L5.5 8.09766L2.375 10.5L3.58594 6.62305L0.5 4.25H4.32812L5.5 0.5L6.67188 4.25H10.5Z" fill="#333333" />
            </svg>
          </div>
        </a>
      </div>
    </div>
    <div class="mt-2">
      <div class="flex items-center">
        <NuxtLink class="venue-name block grow text-2xl font-medium leading-tight text-gray-dark hover:underline" :to="`/${venue.path}`">
          {{ venue.name }}
        </NuxtLink>
        <div class="text-sm text-body">
          {{ venue.distance }} mi
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    venue: { type: Object, required: true },
  },

  emits: ['click'],
}
</script>
